import { defineMessages } from "react-intl";

export default defineMessages({
  title: 'Welcome to {name} message board',
  contact: "Administrator's Contact Information:",
  close: 'Close'
});
